import React from 'react';

import { ChipList } from 'lib.front';
import { generarNombreArchivo } from './helpFunc';

function labelArchivo(item) {
   if (item.file) {
      return generarNombreArchivo(item.file);
   } else {
      return item.urlFile;
   }
}

function ListarArchivos(props) {
   const { archivos, setArchivos, modo, onClickArchivo, metadata } = props;
   function eliminarArchivo(item, index) {
      let newFiles = archivos;
      newFiles.splice(index, 1);
      setArchivos([...newFiles]);
   }

   function hiddeArchivo(file) {
      return (
         metadata !== '' &&
         file.metadata !== null &&
         file.metadata.replaceAll('"', '') !== metadata.replaceAll('"', '')
      );
   }

   const chipProps = {
      clickable: modo !== 'subir',
      variant: 'outlined'
   };

   return (
      <ChipList
         label={modo === 'subir' ? 'Archivos a Subir' : 'Archivos Adjuntos'}
         chips={archivos}
         genChipLabel={labelArchivo}
         onDeleteChip={modo === 'subir' ? eliminarArchivo : undefined}
         onClickChip={onClickArchivo}
         chipProps={chipProps}
         hiddeChip={hiddeArchivo}
         variant="outlined"
      />
   );
}
ListarArchivos.defaultProps = {
   metadata: ''
};
export default ListarArchivos;
